import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  tabPanel: {
    background: 'white',
    position: 'absolute',
    top: -260,
    left: 390,
    width: '120%',
    borderRadius: '8px',
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.palette.shadow.cardBoxShadow,
    padding: '40px 54px 50px',
    zIndex: 2,
    [theme.breakpoints.up(1055)]: {
      top: -86,
    },
    [theme.breakpoints.up(1200)]: {
      top: -230,
      left: 459,
    },
    [theme.breakpoints.up(1400)]: {
      top: -140,
      paddingBottom: 50,
      width: 844,
    },
  },
  tabPanelHeading: {
    textAlign: 'center',
    ...theme.typography.h5,
    color: theme.palette.secondary.light,
    marginBottom: 20,
    marginTop: 0,
  },
  tabPanelsupportiveCopy: {
    textAlign: 'center',
  },
  starCardList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    marginTop: 15,
    [theme.breakpoints.up(1200)]: {
      marginTop: 30,
      flexDirection: 'row',
      justifyContent: 'center',
      rowGap: '20px',
      columnGap: '20px',
    },
  },
  starCard: {
    listStyle: 'none',
    padding: '15px 0',
    margin: 0,
    display: 'flex',
    flexDirection: 'row',
    borderBottom: `0.5pt solid ${theme.palette.primary.main}`,
    [theme.breakpoints.up(1200)]: {
      borderRadius: 8,
      width: '230px',
      height: '160px',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      boxShadow: theme.palette.shadow.cardBoxShadow,
      borderBottom: `8px solid ${theme.palette.primary.main}`,
      padding: '20px 25px 12px',
    },
  },
  starPoint: {
    borderRadius: '50%',
    width: 35,
    height: 35,
    flexBasis: 35,
    flexShrink: 0,
    background: theme.palette.background.default,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 16,
    [theme.breakpoints.up(1200)]: {
      margin: 0,
    },
  },
  starCardCopy: {
    ...theme.typography.h6,
    fontSize: '16px !important',
    lineHeight: '20.05px !important',
    color: theme.palette.secondary.light,
    [theme.breakpoints.up(1200)]: {
      marginTop: 10,
    },
  },
  starIcon: {
    fontSize: '1rem',
    color: theme.palette.primary.main,
  },
  tabPanelFullContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '80px 0',
    position: 'relative',
  },
  bgImage: {
    top: 0,
    left: 0,
    position: 'absolute',
    objectFit: 'cover',
    zIndex: 1,
    width: '100%',
    height: '100%',
  },
  tabPanelFull: {
    zIndex: 99,
    backgroundColor: 'white',
    padding: theme.spacing(8),
    paddingTop: theme.spacing(6),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: '850px',
    borderRadius: '8px',
    width: '90%',
    [theme.breakpoints.down(1200)]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  starCardFull: {
    listStyle: 'none',
    padding: '15px 0',
    margin: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderBottom: `0.5pt solid ${theme.palette.primary.main}`,
    [theme.breakpoints.up(1200)]: {
      flexGrow: 1,
      borderRadius: 8,
      width: '230px',
      height: '160px',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      boxShadow: theme.palette.shadow.cardBoxShadow,
      borderBottom: `8px solid ${theme.palette.primary.main}`,
      padding: '20px 25px 40px',
    },
  },
  tabPanelFullHeading: {
    color: theme.palette.secondary.light,
    marginBottom: 5,
    marginTop: 0,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
  },
  tabPanelFullSupportiveCopy: {
    fontWeight: 700,
    fontSize: '1.125rem',
    marginBottom: 15,
    [theme.breakpoints.up(1200)]: {
      marginBottom: 30,
      marginTop: 10,
    },
  },
  starIconFull: {
    fontSize: '1rem',
    color: theme.palette.secondary.light,
    scale: 1.2,
  },
}))

export default useStyles
